import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ScholarshipCategoryStoreActions,
  ScholarshipCategoryStoreSelectors,
  ScholarshipCategoryStoreReducer,
} from './index';
import { ScholarshipCategoryDto } from '@cradua/data';

@Injectable()
export class ScholarshipCategoryFacade {
  constructor(
    private store: Store<
      ScholarshipCategoryStoreReducer.ScholarshipCategoryPartialState
    >
  ) {}

  scholarshipCategoryRecord$ = this.store.select(
    ScholarshipCategoryStoreSelectors.getSelected
  );
  scholarshipCategoryRecordError$ = this.store.select(
    ScholarshipCategoryStoreSelectors.getScholarshipCategoryError
  );

  getselected() {
    return this.store.select(ScholarshipCategoryStoreSelectors.getSelected);
  }

  get isLoadingScholarshipCategory() {
    this.store.dispatch(
      ScholarshipCategoryStoreActions.loadScholarshipCategory()
    );
    return this.store.select(
      ScholarshipCategoryStoreSelectors.loadingScholarshipCategory
    );
  }

  get loadScholarshipCategory() {
    this.store.dispatch(
      ScholarshipCategoryStoreActions.loadScholarshipCategory()
    );
    return this.store.select(
      ScholarshipCategoryStoreSelectors.getAllScholarshipCategory
    );
  }

  addScholarshipCategory(newScholarshipCategory: ScholarshipCategoryDto[]) {
    this.store.dispatch(
      ScholarshipCategoryStoreActions.addScholarshipCategory({
        newScholarshipCategory,
      })
    );
  }

  updateScholarshipCategory(
    updateScholarshipCategory: ScholarshipCategoryDto[]
  ) {
    this.store.dispatch(
      ScholarshipCategoryStoreActions.updateScholarshipCategory({
        updateScholarshipCategory,
      })
    );
  }

  removeScholarshipCategory(ids: string[]) {
    this.store.dispatch(
      ScholarshipCategoryStoreActions.removeScholarshipCategory({ ids })
    );
  }
}
